<template>
  <div>
    <v-row>
      <v-col cols="12">
        <router-link :to="{ name: 'newInvestorNotices' }">
          <v-btn color="primary">{{ $t('investor_notices.new_notices') }}</v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <CorrectDataTable
          :table-headers="header"
          :table-data="notices_list"
          :page-limit="current_limit"
          :page="current_page"
          :page-limit-options="tablePageLimitOptions"
          :item-total="total_items"
          :is-loading="load_table"
          :enable-search="false"
          :enable-filter="false"
          :enable-date-range="false"
          :enable-clear-all="false"
          :disable-pagination="load_table"
          :disable-sort="true"
          @options-update="onTableChange"
        ></CorrectDataTable>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getData } from '@/api'
import CorrectDataTable from '@/components/CorrectDataTable.vue'
import { globalFunc } from '@/global'

export default {
  name: 'InvestorRelationsNotices',
  components: {
    CorrectDataTable,
  },
  mixins: [globalFunc],
  data: () => ({
    header: [],
    notices_list: [],
    load_table: true,
    total_items: 0,
    current_page: 1,
    current_limit: 10,
    options: {},
    tablePageLimitOptions: [10, 20, 50],
  }),
  methods: {
    initializeHeader() {
      this.header = [
        {
          text: this.$t('investor_notices.publish_date'),
          value: 'publish_date',
        },
        {
          text: this.$t('investor_notices.document_title'),
          value: 'document_title',
        },
        {
          text: this.$t('investor_notices.upload_document'),
          value: 'upload_document',
        },
        { text: '', value: 'investor_notices_button' },
      ]
    },
    async initializeData() {
      try {
        this.load_table = true

        let params = new URLSearchParams()
        params.set(
          'get_all_data_by_data_type',
          JSON.stringify({
            data_type: 'investor_relation_notices_data',
            filter_page: this.current_page - 1,
            filter_limit: this.current_limit,
          }),
        )

        let investorNotices = await getData(params)
        if (Array.isArray(investorNotices)) {
          this.notices_list = []
          this.total_items = 0
        } else {
          let temp = []
          this.total_items = investorNotices.item_count

          for (let i = 0; i < investorNotices.item_list.length; i++) {
            let obj = investorNotices.item_list[i]
            temp.push({
              id: obj.id,
              publish_date: obj.publish_date,
              document_title: obj.document_title.zh,
              upload_document: obj.document.zh,
            })
          }

          this.notices_list = temp
        }

        this.load_table = false
      } catch (error) {
        globalFunc.log(error)
        this.load_table = false
      }
    },
    onTableChange(options) {
      if (options.itemsPerPage !== this.current_limit) {
        this.current_page = 1 // reset to first page if view options changed
      } else {
        this.current_page = options.page
      }

      this.current_limit = options.itemsPerPage
      this.initializeData()
    },
  },
  created() {
    this.initializeHeader()
    this.initializeData()
  },
}
</script>
